/* eslint-disable react/no-unknown-property */
"use client";

import React, { useImperativeHandle, useRef } from "react";

import clsx from "clsx";

import { MentionLinkProps } from "../../interface";
import "./index.scss";

interface ChildComponentRef {
  getDOMNode(): HTMLSpanElement | null;
}

// eslint-disable-next-line react/display-name
const MentionLink = React.forwardRef<ChildComponentRef, MentionLinkProps>(
  (props, ref) => {
    const {
      href,
      children,
      wrapperClassName,
      wrapperStyle,
      ellipsis,
      ...others
    } = props;

    const spanRef = useRef(null);

    useImperativeHandle(ref, () => ({
      getDOMNode: () => spanRef.current,
    }));

    const spanCls = clsx(`mention-link-container ${wrapperClassName || ""}`, {
      truncate: ellipsis,
    });

    const aCls = clsx({
      truncate: ellipsis,
    });

    return (
      <span ref={spanRef} className={spanCls} style={wrapperStyle}>
        <span
          className="mention-link-wrapper link-text-color"
          auto-url-line="0"
          auto-url-start="0"
          auto-url-length={href?.length}
          auto-url={href}
          data-leaf="true"
        >
          <a
            className={aCls}
            href={href}
            data-href={href}
            rel="noopener noreferrer"
            target="_blank"
            data-link-node="true"
            style={{
              ...(ellipsis && {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }),
            }}
            {...others}
          >
            <span data-string="true">{children || href}</span>
          </a>
        </span>
      </span>
    );
  }
);

export default MentionLink;
